import React, { useCallback } from "react";

import GlobalStyle from "./assets/styles/app";
import {
    MainWrapper,
    SectionWrapper,
    TitleWrapper,
    TitleTextWrapper,
    StoresTotalWrapper,
    StoresWrapper,
    NaverWrapper,
} from "./assets/styles/main";

// import TitleImg from "./assets/images/title.png";
import PlayIcon from "./assets/images/play.png";
import AppleStore from "./assets/images/apple.png";
import GoogleStore from "./assets/images/google.png";
import OneStore from "./assets/images/one.png";
import NaverImg from "./assets/images/naver.png";

import Footer from "./components/Footer";
import Nav from "./components/Nav";

import {
    ModalWrapper,
    Content
} from '../../assets/styles/components/modal';

// ui
import { css } from '@emotion/react';
import { ModalProvider, useModal } from "react-modal-hook";
import Backdrop from "../../components/common/Backdrop";

// component
import Seo from "../../components/CommonSeo"

const useGoTo = (url) => useCallback(() => window.location.href = url, [url]);

const App = () => {
    const goToGoogle = useGoTo(process.env.GATSBY_MARKET_GOOGLE_URL);
    const goToApple = useGoTo(process.env.GATSBY_MARKET_APPLE_URL);
    const goToOneStore = useGoTo(process.env.GATSBY_MARKET_ONESTORE_URL);
    const goToNaverLounge = useGoTo(process.env.GATSBY_NAVER_LOUNGE_URL);

    const onPlayClick = useVideoModal();

    return (
        <>
            <Seo />
            <GlobalStyle />
            <MainWrapper>
                <Nav />
                <SectionWrapper>
                    <TitleWrapper>
                        {/* text */}
                        <TitleTextWrapper>
                            <span>야구의 순간을 담다</span>
                            <p className="english">
                                <span>CATCH </span>
                                <span>THE </span>
                                <span>MOMENT</span>
                            </p>
                        </TitleTextWrapper>
                        {/* <img src={TitleImg} className="titleImg" alt="title" /> */}
                        <NaverWrapper src={NaverImg} alt="naver play" onClick={goToNaverLounge} />

                        {/* play icon */}
                        <img
                            src={PlayIcon}
                            className="playIcon"
                            alt="play icon"
                            onClick={onPlayClick}
                        />

                        {/* play stores icons */}
                        <StoresTotalWrapper>
                            <p>아래 버튼을 통해 다운받으실 수 있습니다</p>
                            <StoresWrapper>
                                <img src={AppleStore} alt="app store" onClick={goToApple} />
                                <img src={GoogleStore} alt="google play store" onClick={goToGoogle} />
                                <img src={OneStore} alt="one store" onClick={goToOneStore} />
                            </StoresWrapper>
                        </StoresTotalWrapper>
                    </TitleWrapper>
                </SectionWrapper>
                <Footer />
            </MainWrapper>
        </>
    )
};

const useVideoModal = () => {
    const [show, hide] = useModal(() => (
        <>
            <Backdrop onClose={hide} />
            <ModalWrapper>
                <Content css={css`padding: 0 !important; font-size: inherit !important;`}>
                    <div css={css`line-height: 0; background: black; width: 100%;`}>
                        <iframe
                            style={{ minWidth: "78vw", minHeight: "50vw" }}
                            // TODO: 이곳의 url을 변경하시면 됩니다 (?autoplay=1&mute=1은 그대로 두고 그 전 url만 바꿔주세요!).
                            src="https://www.youtube.com/embed/5Ubg8mrp9M0?autoplay=1&mute=1"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </Content>
            </ModalWrapper>
        </>
    ), []);

    return show;
}

const AppWrapper = () => (
    <ModalProvider>
        <App />
    </ModalProvider>
)
export default AppWrapper;